import React from 'react'
import { Box, Grid, Typography, Card, CardMedia, Divider } from '@mui/material'
import ServicesHeader from './servicesHeader'
import './services.css'

import groundworkExample1 from '../_content/groundworks.webp'
import groundworkExample2 from '../_content/groundworks1.webp'
import groundworkExample3 from '../_content/groundworks2.webp'
import groundworkExample4 from '../_content/groundworks3.webp'

const GroundworksServices = () => {
  return (
    <>
      <ServicesHeader
        background={groundworkExample4}
        text="Groundworks"
      />

      {/* TOP STRIP */}
      <Divider orientation='vertical' flexItem sx={{ border: '1px solid white' }} />
      <Box className="top-strip">
        <Typography className="top-strip-text">
          Reliable groundwork services providing strong, stable foundations for every project, covering Brentwood and Essex.
        </Typography>
      </Box>
      <Divider orientation='vertical' flexItem sx={{ border: '1px solid white' }} />

      {/* WHITE SECTION */}
      <Box className="section-wrapper">
        <Box className="section-inner">
          <Box className="section-content">

            <Typography className="section-heading" variant="h5">
              Solid preparation for long-lasting results
            </Typography>

            <Typography className="section-subtext">
              From site preparation to drainage and foundations, we ensure every project starts with a strong and reliable base.
            </Typography>

            <Box className="section-divider" />

            <Grid container spacing={3} alignItems="stretch">
              {[
                {
                  title: 'Site Preparation',
                  text: 'We carry out excavation, levelling and groundwork preparation tailored to your project requirements.',
                },
                {
                  title: 'Durable Foundations',
                  text: 'Built using quality materials and proven methods to ensure long-term strength and stability.',
                },
                {
                  title: 'Experienced Team',
                  text: 'Skilled professionals delivering reliable workmanship and attention to detail on every job.',
                },
              ].map((item, i) => (
                <Grid item xs={12} md={4} key={i} sx={{ display: 'flex' }}>
                  <Box className="service-card">
                    <Box>
                      <Typography className="card-title">{item.title}</Typography>
                      <Typography className="card-text">{item.text}</Typography>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>

          </Box>
        </Box>
      </Box>

      {/* IMAGE SECTION */}
      <Box className="image-section">
        <Typography className="image-title" variant="h5">
          Recent Projects
        </Typography>

        <Grid container spacing={3} justifyContent="center">
          {[groundworkExample1, groundworkExample2, groundworkExample3].map((img, i) => (
            <Grid item xs={12} sm={6} md={4} key={i}>
              <Card className="image-card">
                <CardMedia
                  component="img"
                  image={img}
                  alt={`Groundworks example ${i + 1}`}
                  className="image-media"
                />
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  )
}

export default GroundworksServices